export enum EnumTpSubItem {
  InsumoProducao = 0,
  InsumoProducaoFixo = 1,
  InsumoAutomatico = 2,
  InsumoAutomaticoFixo = 3,
}
